





























































































































import { Input, Button } from 'element-ui'
import { mixins } from 'vue-class-component'
import { Vue, Component, Ref } from 'vue-property-decorator'
import { Route, Location } from 'vue-router'

import BookingTopNav from '@/components/BookingTopNav.vue'
import LoadingPlaceholder from '@/components/LoadingPlaceholder.vue'
import RoundAvatar from '@/components/RoundAvatar.vue'

import Customer from '@/models/customer'
import Message from '@/models/message'
import User from '@/models/user'

import { compactDateFormat } from '@/globalFilters'
import BookingHeaderTitleMixin from '@/mixins/BookingHeaderTitleMixin.vue'
import store from '@/store'
import { BookingsActionTypes } from '@/store/modules/bookings'
import { MessagesActionTypes, MessagesGetters } from '@/store/modules/messages'

@Component({
  components: {
    BookingTopNav,
    [Input.name]: Input,
    [Button.name]: Button,
    RoundAvatar,
    LoadingPlaceholder,
  },
})
export default class BookingMessagesPage extends mixins(
  BookingHeaderTitleMixin,
) {
  @Ref() readonly newMessageInput!: Input

  newMessage = ''
  pollingIntervalId = 0
  dateFormat = compactDateFormat

  beforeRouteEnter(to: Route, from: Route, next: (to?: Location) => void) {
    store.dispatch(BookingsActionTypes.Get, to.params.id)
    store.dispatch(MessagesActionTypes.LoadByBookingId, to.params.id)

    next()
  }

  created() {
    // FIXME: it should save intervalId to store and reset it with Reset mutation
    this.pollingIntervalId = window.setInterval(() => {
      store.dispatch(
        MessagesActionTypes.UpdateByBookingId,
        this.$route.params.id,
      )
    }, 10000)
  }

  beforeDestroy() {
    clearInterval(this.pollingIntervalId)
  }

  get messagesLoaded(): boolean {
    return this.$store.state.messages.messagesLoaded
  }

  get messages() {
    return this.$store.getters[MessagesGetters.Messages].map(
      (message: Message) => {
        if (message.userId) {
          message.person = this.getUser(message.userId)
        } else if (message.customerId) {
          message.person = this.getCustomer(message.customerId)
        }

        return message
      },
    )
  }

  get currentCustomer() {
    return this.$store.getters.getCurrentCustomer
  }

  get lastMessage() {
    return this.messages.slice(-1)[0]
  }

  getUser(id: number): User {
    return this.$store.getters.getUserById(id)
  }

  getCustomer(id: number): Customer {
    return this.$store.getters.getCustomerById(id)
  }

  getDisplayName(message: Message): string {
    const { person } = message
    const name = person?.firstName || person?.email || 'Unknown'
    const postfix = message.userId ? this.companyName : ''
    return `${name}, ${postfix}`
  }

  get messagesPlaceholder() {
    if (window.innerWidth > 400) {
      return 'ContentLoaderBookingMessage'
    } else {
      return 'ContentLoaderBookingMessageMobile'
    }
  }

  sendMessage() {
    if (this.newMessage.trim().length) {
      this.$store.dispatch(MessagesActionTypes.Send, {
        customer: this.currentCustomer.email,
        newMessage: this.newMessage,
        bookingId: this.$route.params.id,
      })

      this.newMessage = ''
    }
  }
}
